import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-5"
};
const _hoisted_2 = {
  class: "rounded-lg border border-slate-200 bg-white p-5 shadow-sm"
};
const _hoisted_3 = {
  key: 0,
  class: "py-10 text-center text-sm text-slate-500"
};
const _hoisted_4 = {
  key: 1,
  class: "py-10 text-center text-sm text-slate-500"
};
const _hoisted_5 = {
  key: 2,
  class: "space-y-5"
};
const _hoisted_6 = {
  class: "flex flex-wrap items-start justify-between gap-4 border-b border-slate-200 pb-4"
};
const _hoisted_7 = {
  class: "font-mono text-sm text-slate-500"
};
const _hoisted_8 = {
  class: "mt-2 flex flex-wrap items-center gap-2"
};
const _hoisted_9 = {
  class: "text-right"
};
const _hoisted_10 = {
  class: "font-mono text-sm text-slate-900"
};
const _hoisted_11 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-4"
};
const _hoisted_12 = {
  class: "rounded-lg border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_13 = {
  class: "mt-2 whitespace-pre-wrap text-sm text-slate-700"
};
const _hoisted_14 = {
  key: 0,
  class: "rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700"
};
const _hoisted_15 = {
  class: "rounded-lg border border-slate-200 bg-white shadow-sm"
};
const _hoisted_16 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_17 = {
  class: "data-table-scroll"
};
const _hoisted_18 = {
  class: "data-table text-sm"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  class: "data-table-td"
};
const _hoisted_22 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_23 = {
  class: "data-table-td is-right"
};
const _hoisted_24 = {
  class: "data-table-td is-right"
};
const _hoisted_25 = {
  class: "data-table-td"
};
const _hoisted_26 = {
  class: "data-table-td is-right"
};
import { computed, defineComponent, h, ref, watch } from 'vue';
import { getWealthOperationApply, getWealthOperationApplyBatchDetails, getWealthOperationApplyBatchDetailsByApprovalInstanceId, getWealthOperationApplyByApprovalInstanceId } from '@/api/wealth';
import WealthAttachmentPanel from './WealthAttachmentPanel.vue';
import WealthStatusBadge from './WealthStatusBadge.vue';
import { formatDate, formatDateTime, formatMoney, formatRate } from '../utils';
export default {
  __name: 'WealthOperationApplyBusinessDetail',
  props: {
    applyId: {
      type: [Number, String],
      default: null
    },
    approvalInstanceId: {
      type: [Number, String],
      default: null
    }
  },
  setup(__props) {
    const FieldBlock = defineComponent({
      name: 'FieldBlock',
      props: {
        label: {
          type: String,
          required: true
        },
        value: {
          type: [String, Number],
          default: '-'
        },
        strong: {
          type: Boolean,
          default: false
        }
      },
      setup(props) {
        return () => h('div', [h('div', {
          class: 'text-xs text-slate-500'
        }, props.label), h('div', {
          class: props.strong ? 'mt-1 font-semibold text-slate-900' : 'mt-1 text-sm text-slate-700'
        }, props.value || '-')]);
      }
    });
    const props = __props;
    const loading = ref(false);
    const detailLoading = ref(false);
    const apply = ref({});
    const details = ref([]);
    const failureReason = computed(() => {
      return apply.value.accountFailedReason || apply.value.approvalStartFailedReason || '';
    });
    const customerDisplayName = computed(() => {
      return apply.value.wealthCustomerName || apply.value.customerName || '-';
    });
    const contractDisplayName = computed(() => {
      if (apply.value.contractName && apply.value.contractNo) {
        return `${apply.value.contractName}（${apply.value.contractNo}）`;
      }
      return apply.value.contractName || apply.value.contractNo || '-';
    });
    async function loadApply() {
      const approvalInstanceId = Number(props.approvalInstanceId);
      const applyId = Number(props.applyId);
      const useApprovalInstance = Number.isFinite(approvalInstanceId) && approvalInstanceId > 0;
      const id = useApprovalInstance ? approvalInstanceId : applyId;
      if (!Number.isFinite(id) || id <= 0) {
        apply.value = {};
        details.value = [];
        return;
      }
      loading.value = true;
      detailLoading.value = true;
      try {
        const getApply = useApprovalInstance ? getWealthOperationApplyByApprovalInstanceId : getWealthOperationApply;
        const getDetails = useApprovalInstance ? getWealthOperationApplyBatchDetailsByApprovalInstanceId : getWealthOperationApplyBatchDetails;
        const [applyResult, detailResult] = await Promise.all([getApply(id), getDetails(id)]);
        apply.value = applyResult || {};
        details.value = detailResult || [];
      } finally {
        loading.value = false;
        detailLoading.value = false;
      }
    }
    watch(() => [props.applyId, props.approvalInstanceId], loadApply, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, "加载中...")) : !apply.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_4, "未找到申请")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_7, _toDisplayString(apply.value.applyNo), 1), _createElementVNode("div", _hoisted_8, [_createVNode(WealthStatusBadge, {
        type: "operation",
        value: apply.value.operationType
      }, null, 8, ["value"]), _createVNode(WealthStatusBadge, {
        type: "apply",
        value: apply.value.status,
        "show-dot": ""
      }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_9, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "text-xs text-slate-500"
      }, "审批实例", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(apply.value.approvalInstanceId || '-'), 1)])]), _createElementVNode("div", _hoisted_11, [_createVNode(_unref(FieldBlock), {
        label: "申请金额",
        value: `¥${_unref(formatMoney)(apply.value.amount)}`,
        strong: ""
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "续期本金",
        value: `¥${_unref(formatMoney)(apply.value.rolloverPrincipalAmount)}`,
        strong: ""
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "客户名称",
        value: customerDisplayName.value
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "合同名称",
        value: contractDisplayName.value
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "目标批次",
        value: apply.value.targetBatchNoSnapshot || apply.value.targetBatchId || '-'
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "年利率（%）",
        value: _unref(formatRate)(apply.value.annualRate)
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: apply.value.operationType === 'INVEST' ? '注资日期' : '起息日',
        value: _unref(formatDate)(apply.value.valueDate)
      }, null, 8, ["label", "value"]), _createVNode(_unref(FieldBlock), {
        label: "到期日",
        value: _unref(formatDate)(apply.value.maturityDate)
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "申请人",
        value: apply.value.applicantName || apply.value.applicantUserId || '-'
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "申请时间",
        value: _unref(formatDateTime)(apply.value.applyTime)
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "审批结果时间",
        value: _unref(formatDateTime)(apply.value.reviewResultTime)
      }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
        label: "落账时间",
        value: _unref(formatDateTime)(apply.value.accountedTime)
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_12, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "text-xs font-medium text-slate-500"
      }, "说明", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(apply.value.description || '-'), 1)]), failureReason.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(failureReason.value), 1)) : _createCommentVNode("", true)]))]), _createElementVNode("section", _hoisted_15, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "border-b border-slate-200 px-4 py-3"
      }, [_createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-900"
      }, "批次明细")], -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("table", _hoisted_18, [_cache[4] || (_cache[4] = _createElementVNode("thead", {
        class: "data-table-head"
      }, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "data-table-th text-left"
      }, "批次"), _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "金额"), _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "提交前本金"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "起止日期"), _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "年利率（%）")])], -1)), _createElementVNode("tbody", null, [detailLoading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[2] || (_cache[2] = [_createElementVNode("td", {
        colspan: "5",
        class: "data-table-empty"
      }, "加载中...", -1)]))])) : details.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[3] || (_cache[3] = [_createElementVNode("td", {
        colspan: "5",
        class: "data-table-empty"
      }, "暂无明细", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 2
      }, _renderList(details.value, item => {
        return _openBlock(), _createElementBlock("tr", {
          key: item.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(item.batchNoSnapshot || item.batchId || '-'), 1)]), _createElementVNode("td", _hoisted_23, "¥" + _toDisplayString(_unref(formatMoney)(item.amount)), 1), _createElementVNode("td", _hoisted_24, "¥" + _toDisplayString(_unref(formatMoney)(item.beforeBatchPrincipalSnapshot)), 1), _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatDate)(item.valueDateSnapshot)) + " 至 " + _toDisplayString(_unref(formatDate)(item.maturityDateSnapshot)), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(formatRate)(item.annualRateSnapshot)), 1)]);
      }), 128))])])])])]), apply.value.id ? (_openBlock(), _createBlock(WealthAttachmentPanel, {
        key: 0,
        title: "申请附件",
        "biz-type": "OPERATION_APPLY",
        "biz-id": apply.value.id,
        "can-manage": false
      }, null, 8, ["biz-id"])) : _createCommentVNode("", true)]);
    };
  }
};